/**
 * External dependencies
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Internal dependencies
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';
import './style.scss';

const { name } = metadata;

export { metadata, name };

/**
 * Function to register an individual block.
 *
 * @param {Object} block The block to be registered.
 *
 * @return {WPBlockType | undefined} The block, if it has been successfully registered;
 *                        otherwise `undefined`.
 */
export default function initBlock( block ) {
	if ( ! block ) {
		return;
	}
	const { settings } = block;
	return registerBlockType( { name, ...metadata }, settings );
}

export const settings = {
	example: {
		innerBlocks: [
			{
				name: 'suredash/dynamic-icon',
				attributes: {
					service: 'User',
					url: '#',
				},
			},
			{
				name: 'suredash/dynamic-icon',
				attributes: {
					service: 'Settings',
					url: '#',
				},
			},
			{
				name: 'suredash/dynamic-icon',
				attributes: {
					service: 'Bell',
					url: '#',
				},
			},
		],
	},
	icon: (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-monitor-up-icon lucide-monitor-up" style={ { fill: 'none', width: '16px' } }><path d="m9 10 3-3 3 3" /><path d="M12 13V7" /><rect width="20" height="14" x="2" y="3" rx="2" /><path d="M12 17v4" /><path d="M8 21h8" /></svg>
	),
	edit,
	save,
};

initBlock( { name, metadata, settings } );
